const Map = () => {
  return (
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3231.8440646742456!2d14.488734!3d35.9018346!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x130e454c6b8cc76f%3A0x5a3449d32de713df!2zMTUxIFRyaXEgRWRnYXIgQmVybmFyZCwgSWwtR8W8aXJhLCDQnNCw0LvRjNGC0LA!5e0!3m2!1sru!2sua!4v1752746020142!5m2!1sru!2sua"
      loading="lazy"
      style={{ width: "100%", height: "100%", border: "0" }}
      allowFullScreen
    />
  );
};

export default Map;
